import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
export const Timer = ({ timeLimit, onTimesUp, isHide }) => {
    const intervalId = useRef(null);
    const [timer, setTimer] = useState(timeLimit || 60);
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        let seconds = String(time % 60);
        if (Number(seconds) < 10) {
            seconds = `0${seconds}`;
        }
        return `${minutes}:${seconds}`;
    };
    useEffect(() => {
        if (timer <= 0) {
            onTimesUp();
            clearInterval(intervalId.current);
        }
    }, [timer]);
    useEffect(() => {
        if (timer > 0) {
            intervalId.current = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => {
            clearInterval(intervalId.current);
        };
    }, []);
    if (isHide)
        return _jsx(_Fragment, {});
    return _jsx("span", { children: formatTime(timer) });
};
